import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { CodaltComponent } from '../codalt.component';
import { CustomerProject } from '../customer-project.interface';
import { LocalStorage } from '../local-storage.class';
import { AuthService } from '../services/auth/auth.service';
import { ConfirmDialogService } from '../services/confirm-dialog-service/confirm-dialog.service';
import { CustomerProjectService } from '../services/customer-project/customer-project.service';
import { PageTitleService } from '../services/page-title/page-title.service';
import { UserService } from '../services/user/user.service';
import { WorkareaService } from '../services/workarea/workarea.service';
import { Settings } from '../settings.class';
import { User } from '../user.interface';
import { Utils } from '../utils.class';
import { AddCustomerProjectModalComponent } from './add-customer-project-modal/add-customer-project-modal.component';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false,
})
export class SettingsComponent extends CodaltComponent implements OnInit {
    public settings: any = { statusses: [] };
    public Utils = Utils;

    public StaticSettings = Settings;

    public version: any = { commit: 'unknown', datetime: Date.now(), version: 'unknown' };

    public LocalStorage = LocalStorage;

    public user: User;

    public markers = {};

    public staticmapsettings = [
        {
            key: 'show_cancelled',
            description: 'Toon afgebroken werkvakken',
        },
        {
            key: 'show_executed_month',
            description: 'Toon uitgevoerde werkvakken ouder dan 1 maand',
        },
        {
            key: 'show_executed_year',
            description: 'Toon uitgevoerde werkvakken ouder dan 1 jaar',
        },
        {
            key: 'show_approved',
            description: 'Toon goedgekeurde werkvakken',
        },
        {
            key: 'show_own',
            description: 'Toon enkel eigen werkvakken',
        },
        {
            key: 'hide_clusters',
            description: 'Groepering van werkvakken uitschakelen',
        },
    ];

    constructor(
        private http: HttpClient,
        private router: Router,
        private confirmDialogService: ConfirmDialogService,
        private workareaService: WorkareaService,
        private customerProjectService: CustomerProjectService,
        private userService: UserService,
        private matDialog: MatDialog,
        private authService: AuthService,
        private pageTitleService: PageTitleService
    ) {
        super();
        if (Object.keys(Settings.mapSettings).length === 0) {
            this.staticmapsettings.forEach(setting => {
                if (!Settings.mapSettings[setting.key]) {
                    Settings.mapSettings[setting.key] = true;
                }
            });
        }
    }

    removeCustomerProject(customerProject: CustomerProject) {
        this.customerProjectService.unfollow(customerProject.id).subscribe(
            () => this.authService.getUserDetails().subscribe(() => (this.user = LocalStorage.getUser())),
            () =>
                this.confirmDialogService.confirm(
                    'Uitschrijven mislukt',
                    'Het is niet gelukt om je uit te schrijven voor ' + customerProject.name
                )
        );
    }

    addCustomerProject() {
        this.subscriptions.add(
            this.matDialog
                .open(AddCustomerProjectModalComponent, {
                    width: '32rem',
                    maxWidth: 'calc(100vw - 2rem)',
                    maxHeight: 'calc(100vh - 2rem)',
                })
                .afterClosed()
                .subscribe(() =>
                    this.authService.getUserDetails().subscribe(() => (this.user = LocalStorage.getUser()))
                )
        );
    }

    ngOnInit() {
        this.pageTitleService.setTitle('Profiel');
        this.user = LocalStorage.getUser();
        this.authService.getUserDetails().subscribe(() => (this.user = LocalStorage.getUser()));
        lastValueFrom(this.http.get('assets/version.json'))
            .then(versionInfo => (this.version = versionInfo))
            .catch(() => {});
    }

    logout() {
        this.authService.logout().subscribe(() => this.router.navigate([this.Routenames.logout], { replaceUrl: true }));
    }

    mapSettingsChanged() {
        this.workareaService.resetLastCustomerId();
        LocalStorage.setMapSettings(Settings._mapSettings);
    }

    projectEmailNotifChanged(event: MatSlideToggleChange) {
        this.subscriptions.add(
            this.userService.changeUserSettings(event.checked).subscribe({
                next: response => {
                    this.user.settings = response.data;
                    LocalStorage.setUser(this.user);
                },
                // Put the toggle back, otherwise it keeps showing a value that was never saved.
                error: () => (event.source.checked = !event.checked),
            })
        );
    }
}
